import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import dropdownNavigationHOC from '../dropdown-navigation-hoc';
import { FormattedMessage, injectIntl } from 'react-intl';

const ListContainer = ({ children }) => (
  <ul
    tabIndex="-1"
    role="listbox"
    className="dropdown-list"
    aria-labelledby={null}
    style={{ minWidth: '220px', margin: '0 -1px' }}
  >
    { children }
  </ul>
);

const ErrorDropdown = ({ toggleModal, listToggle }) => (
  <ListContainer>
    <div style={{ padding: '16px' }}>
      <div>
        <FormattedMessage id="search.location_error_dropdown.dont_recognize" defaultMessage="We don't recognize that location" />
      </div>
    </div>
  </ListContainer>
);

const EmailDropdown = ({ metros, toggleModal, listToggle }) => (
  <ListContainer>
    <div style={{ padding: '16px' }}>
      <FormattedMessage id="search.location_email_dropdown.is_not_there" defaultMessage="Peerspace is not there yet but we're live in" />
      <button
        className="btn-link remove-click-styling no-gutter"
        onClick={(e) => { toggleModal(e, listToggle); }}
      >
        <FormattedMessage
          id="search.location_email_dropdown.check_them_out"
          defaultMessage="{length} cities, check them out."
          values={{
            length: metros.length
          }}
        />
      </button>
    </div>
    <div style={{ padding: '0 16px 16px' }}>
      <FormattedMessage
        id="search.location_email_dropdown.adding_unique_spaces"
        defaultMessage="We're adding unique spaces in cities all over the world. {link} and you'll be the first one to know."
        values={{
          link: <a href="http://try.peerspace.com/global/"><FormattedMessage id="search.location_email_dropdown.leave_email" defaultMessage="Leave your email" /></a>
        }}
      />
    </div>
  </ListContainer>
);

const LocationList = dropdownNavigationHOC(({ data, clickPoi, listToggle, index, onKeyDownList }) => {
  const {
    description,
    place_id: placeId,
    matched_substrings: matchedSubstring
  } = data;

  let end = 0;
  for (let i = 0; i < matchedSubstring.length; i++) {
    if (0 === i) {
      end = matchedSubstring[i].length;
    }
    end = matchedSubstring[i].offset + matchedSubstring[i].length;
  }
  const boldLetters = description.substring(0, end);
  const remainingLetters = description.substring(boldLetters.length, description.length);
  return (
    <li
      key={placeId}
      id={`location-list-${index}`}
      tabIndex="0"
      role="option"
      aria-selected="true"
      className={`border-bottom ${0 === index && 'gray-light-bg'}`}
      data-value={placeId}
      onClick={(e) => { clickPoi(e, listToggle); }}
      onKeyDown={onKeyDownList}
      style={{ padding: '16px' }}
    >
      <div className="ellipsis">
        <b>{boldLetters}</b><span>{remainingLetters}</span>
      </div>
    </li>
  );
});

const LocationDropdown = ({ locations, intl, ...props }) => {
  return (
    <ListContainer>
      {
        [
          map(locations, (data, index) => {
            return (
              <LocationList key={data.place_id} data={data} {...props} index={index} />
            );
          }),
          <div tabIndex="-1" className="text-center" style={{ padding: '15px' }}>
            <img style={{ width: 150 }} src="/web-2/assets/images/powered_by_google.png?v=rb" alt={ intl.formatMessage({ id: 'search.location_dropdown.powered_google', defaultMessage: 'powered by Google' }) } />
          </div>
        ]
      }
    </ListContainer>
  );
};

export const SearchLocationDropdown = ({ whichDropdown, ...props }) => {
  if (!whichDropdown) { return null; }

  let Component;
  switch (whichDropdown) {
  case 'location':
    Component = injectIntl(LocationDropdown);
    break;
  case 'email':
    Component = EmailDropdown;
    break;
  case 'error':
    Component = ErrorDropdown;
  }
  return <Component {...props} />;
};

ErrorDropdown.propTypes = {
  listToggle: PropTypes.func,
  toggleModal: PropTypes.func
};

EmailDropdown.propTypes = {
  metros: PropTypes.array,
  listToggle: PropTypes.func,
  toggleModal: PropTypes.func
};

ListContainer.propTypes = {
  children: PropTypes.node.isRequired
};

LocationList.propTypes = {
  data: PropTypes.object.isRequired,
  clickPoi: PropTypes.func.isRequired,
  listToggle: PropTypes.func,
  onKeyDownList: PropTypes.func,
  index: PropTypes.number
};

LocationDropdown.propTypes = {
  locations: PropTypes.object,
  intl: PropTypes.object
};

SearchLocationDropdown.propTypes = {
  whichDropdown: PropTypes.string
};
